// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PayorCoveragePharmacyCoveragePharmacyCoverageResponse {
    static getAttributeTypeMap() {
        return PayorCoveragePharmacyCoveragePharmacyCoverageResponse.attributeTypeMap;
    }
}
PayorCoveragePharmacyCoveragePharmacyCoverageResponse.discriminator = undefined;
PayorCoveragePharmacyCoveragePharmacyCoverageResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "PayorAccountPharmacyCoverageModels"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    }
];
//# sourceMappingURL=payorCoveragePharmacyCoveragePharmacyCoverageResponse.js.map